<script setup>
  import { ref } from 'vue';
  import { getElementColor, getElementAltColor } from './misc.js';

  let mouseover = ref(false);
  let props = defineProps(['data', 'visible', 'colors', 'editable', 'disableInteract']);
  let emit = defineEmits(['focus', 'blur']);

  function getFilter () {
    let hover = mouseover.value ? (props.data.hover || props.data.nonhover) : (props.data.nonhover);

    if (!hover || hover === 'none') {
      return null;
    }

    return hover;
  }

  function emitFocus (e) {
    emit('focus', e);
  }

  function emitBlur (e) {
    emit('blur', e);
  }
</script>

<template>
  <g :transform="[
      'translate(' + Number(data.x) + ' ' + Number(data.y) + ')',
      data.transform,
    ].filter(Boolean).join(' ')"
    :transform-origin="[data.width / 2, data.height / 2].join(' ')"
    :style="{
    opacity: visible ? 1 : 0,
    cursor: data.action.length ? 'pointer' : false,
  }" :aria-hidden="!visible || visible === 'obscured' ? 'true' : 'false'" :class="{
    'frame-element': true,
    'no-interact': !visible || visible === 'obscured',
  }" :filter="getFilter()">
    <rect class="no-interact" x="0" y="0" :width="data.width" :height="data.height" :fill="getElementAltColor(data, colors, mouseover)" stroke="none" :opacity="data.backgroundOpacity" />
    <template v-if="disableInteract === true || disableInteract === false">
      <foreignObject x="0" y="0" :width="data.width" :height="data.height" :class="{
        'no-interact': disableInteract,
      }">
        <div xmlns="http://www.w3.org/1999/xhtml" :style="{
          display: visible && visible !== 'obscured' ? 'block' : 'none',
          width: '100%',
          height: '100%',
          color: getElementColor(data, colors, mouseover),
        }" :class="{
          'no-interact': disableInteract,
        }">
          <slot></slot>
        </div>
      </foreignObject>
      <rect
        :role="data.action.length ? 'button' : 'none'"
        :tabindex="visible && visible !== 'obscured' && (data.action.length || editable) ? 0 : -1"
        :class="{
          'interact-element': visible && visible !== 'obscured' && (data.action.length || editable),
          'replace': visible && visible !== 'obscured' && (data.action.length || editable),
          'no-interact': !disableInteract,
        }"
        @mouseenter="mouseover = true"
        @mouseleave="mouseover = false"
        @focus="emitFocus"
        @blur="emitBlur"
        x="0"
        y="0"
        :width="data.width"
        :height="data.height"
        :fill="visible && visible !== 'obscured' && (data.action.length || editable) ? '#000' : 'none'"
      />
    </template>
    <template v-else>
      <foreignObject x="0" y="0" :width="data.width" :height="data.height" class="no-interact">
        <div xmlns="http://www.w3.org/1999/xhtml" :style="{
          display: visible ? 'block' : 'none',
          width: '100%',
          height: '100%',
          color: getElementColor(data, colors, mouseover),
        }" class="no-interact">
          <slot></slot>
        </div>
      </foreignObject>
      <rect
        :role="data.action.length ? 'button' : 'none'"
        :tabindex="visible && visible !== 'obscured' && (data.action.length || editable) ? 0 : -1"
        :class="visible && visible !== 'obscured' && (data.action.length || editable) ? 'interact-element replace' : ''"
        @mouseenter="mouseover = true"
        @mouseleave="mouseover = false"
        @focus="emitFocus"
        @blur="emitBlur"
        x="0"
        y="0"
        :width="data.width"
        :height="data.height"
        :fill="visible && visible !== 'obscured' && (data.action.length || editable) ? '#000' : 'none'"
      />
    </template>
  </g>
</template>

<style scoped>

</style>
